/**
 * Stripe.js, loaded from Stripe's own origin when first needed (never
 * bundled: Stripe asks for it to be served from js.stripe.com). Only the
 * embedded Checkout slice is typed; tests hand in a fake loader.
 */
export interface EmbeddedCheckout { mount(target: HTMLElement): void; destroy(): void; }
export interface StripeJs { initEmbeddedCheckout(options: { clientSecret: string }): Promise<EmbeddedCheckout>; }
export type LoadStripe = (publishableKey: string) => Promise<StripeJs | null>;

const SRC = 'https://js.stripe.com/v3/';
let loading: Promise<((key: string) => StripeJs) | null> | null = null;

/** The production loader: one script tag, shared by every call. */
export const loadStripeJs: LoadStripe = async (publishableKey) => {
  const w = window as unknown as { Stripe?: (key: string) => StripeJs };
  if (!w.Stripe) {
    loading ??= new Promise((resolve) => {
      const s = document.createElement('script');
      s.src = SRC; s.async = true;
      s.onload = () => resolve(w.Stripe ?? null);
      s.onerror = () => resolve(null);
      document.head.appendChild(s);
    });
    const factory = await loading;
    if (!factory) return null;
  }
  return w.Stripe ? w.Stripe(publishableKey) : null;
};
